import { useQuery } from "@tanstack/react-query";
import { getJson } from "../../lib/http";

// Retransmisión a integradores (Recurso Confiable, SESE, CMA…). Sólo existe en
// v5, por compañía; SG la cruza con la cuenta por origin_ids.v5. Wialon y Mapon
// no exponen la suya, por eso ahí se muestra «sin dato» y no «no».

export interface Retransmission {
  company_id: string;
  id: string;
  active: boolean;
  integrator_id: string | null;
  integrator_name: string | null;
  scope_type: string | null;
  last_retransmission_at: number | null;
}

// company_id de v5 -> nombres de integrador con retransmisión activa.
export type RetransmissionsByCompany = Map<string, string[]>;

export function groupRetransmissions(list: Retransmission[]): RetransmissionsByCompany {
  const out: RetransmissionsByCompany = new Map();
  for (const r of list) {
    if (!r.active || !r.company_id) continue;
    const names = out.get(r.company_id) ?? [];
    const name = r.integrator_name || r.integrator_id || "—";
    if (!names.includes(name)) names.push(name);
    out.set(r.company_id, names);
  }
  return out;
}

export async function fetchRetransmissions(signal?: AbortSignal): Promise<RetransmissionsByCompany> {
  const res = await getJson<{ data?: Retransmission[] }>("/sg-sync/retransmissions", undefined, { signal });
  return groupRetransmissions(res.data ?? []);
}

// Sin reintentos: si el API todavía no tiene la ruta (404) la columna queda en
// «sin dato» y el resto de la pantalla sigue.
export function useRetransmissions() {
  return useQuery({
    queryKey: ["sg-retransmissions"],
    queryFn: ({ signal }) => fetchRetransmissions(signal),
    staleTime: 10 * 60_000,
    retry: false,
  });
}
